export default function ButtonMenuFallback() {
  return (
    <div className="flex gap-3 justify-center m-auto z-[9] py-4 static top-auto left-auto animate-pulse">
      <div className="flex gap-3 justify-center min-w-[200px] py-3 px-3 rounded-md bg-blue700 h-12"></div>
      <div className="flex gap-3 justify-center min-w-[200px] py-3 px-3 rounded-md bg-blue700 h-12"></div>
      <div className="flex gap-3 justify-center min-w-[200px] py-3 px-3 rounded-md bg-blue700 h-12"></div>
    </div>
  );
}
